import { useGuestSiteUnlockState } from './useGuestSiteUnlockState';
import { useMcpPreviewForceSsr } from '@shared/context/mcpPreviewForceSsr';

/** Shared draft-preview visibility for guest widgets/nav; adds the pending/authorized grant signals. See MCP_PREVIEW.md#visibility-only, #draft-gate. */
export const useDraftPreviewVisibility = (eventHandle: string | undefined) => {
  const unlockState = useGuestSiteUnlockState(eventHandle);
  const isMcpPreview = useMcpPreviewForceSsr();
  const isDraftViewAuthorizationPending = isMcpPreview && unlockState.isUnlockStateLoading;
  return {
    ...unlockState,
    isMcpPreview,
    isDraftViewAuthorizationPending,
    isDraftViewAuthorized: unlockState.canPreviewDraft || isDraftViewAuthorizationPending,
  };
};
